"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  const filteredMenuItems = menuItems.filter(item => item.label !== "Lodging Amenities");
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {filteredMenuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild className="relative px-4 py-2 text-sm font-medium text-foreground transition-colors duration-[var(--duration-medium)] hover:text-primary-dark hover:!bg-transparent focus:!bg-transparent after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] after:ease-[var(--ease-smooth)] hover:after:w-full focus:after:w-full">
                <Link to={item.href || "#"}>
                  {item.label === "San Juan River" ? "Home" : item.label === "Fly Fishing Website Lodging Options" ? "Lodging Options" : item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-5" /> : <Menu className="size-5" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 w-full bg-background border-t border-border shadow-soft md:hidden">
          <nav className="container py-4 flex flex-col gap-2">
            {filteredMenuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="px-4 py-2 text-sm font-medium text-foreground hover:text-foreground hover:bg-accent/50 rounded-md transition-colors duration-[var(--duration-fast)]" onClick={() => setMobileMenuOpen(false)}>
                {item.label === "San Juan River" ? "Home" : item.label === "Fly Fishing Website Lodging Options" ? "Lodging Options" : item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={`sticky top-0 z-50 w-full border-b border-border bg-background/80 backdrop-blur-md transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "h-16" : "h-[90px]"}`}>
      <div className="container mx-auto h-full flex items-center justify-between">
        {}
        <Link to="/HomePage#" className="flex-shrink-0">
          <img src="https://wildflyfishingnm.10web.cloud/wp-content/uploads/2026/02/Black-and-White-Circle-Fishing-Club-Logo.png" alt="Wild Fly Fishing LLC" className="!w-[100px] !h-[100px]" />
        </Link>

        {}
        <div className="flex-1 flex justify-center">
          <MenuProvider menu_id="33">
            <HeaderMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <Button asChild className="flex-shrink-0 hover:!bg-primary-hover hover:-translate-y-0.5 transition-all duration-[var(--duration-fast)] ease-[var(--ease-out-back)] focus:!bg-primary-active">
          <Link to="/ContactPage" newTab={false}>
            Book Your Trip
          </Link>
        </Button>
      </div>
    </header>;
}